import styled from "@emotion/styled";
import { Box, Stack, Typography } from "@mui/material";
import { Modal } from "Components/_Shared/BlModal";
import { Button } from "Components/_Shared/Buttons/Button";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

type Props = {
  readonly isOpen: boolean;
  readonly handleResult: (result: boolean) => void;
};

const StyledWrapper = styled(Box)`
  width: ${(props) => props.theme.spacing(150)};
  border-radius: ${(props) => props.theme.spacing(Radius.XXXL)};
  padding: ${(props) => props.theme.spacing(Spacing.XXL)};
  background: ${(props) => props.theme.colors.white};
`;

export const ConfirmRecalculateTargetModal: React.FunctionComponent<Props> = ({ isOpen, handleResult }) => {
  const { t } = useResource();

  return (
    <Modal open={isOpen} onClose={() => handleResult(false)}>
      <StyledWrapper sx={{ boxShadow: 3 }}>
        <Stack spacing={Spacing.XL}>
          <Typography variant="h2">{t(Resources.AnalysisDetail.Assets.ModelingModal.Title)}</Typography>
          <Typography variant="body2" color="secondary">
            {t(Resources.AnalysisDetail.Goals.ConfirmRecalculateTargetFromMonthly)}
          </Typography>
          <Box display="flex" justifyContent="flex-end">
            <Box mr={Spacing.XL}>
              <Button color="secondary" onClick={() => handleResult(false)}>
                {t(Resources.Common.Cancel)}
              </Button>
            </Box>
            <Button onClick={() => handleResult(true)}>{t(Resources.Common.Yes)}</Button>
          </Box>
        </Stack>
      </StyledWrapper>
    </Modal>
  );
};
